module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-contract-first/bg.png",
      "swiper": _vm.swiper,
      "hasDownBtn": true
    }
  }, [_c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.firstContractDate))]), _c('br'), _vm._v("\n    是您第一个合同的签订日"), _c('br'), _vm._v("\n    您购买的产品为"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.firstContractProduct))]), _c('br'), _vm._v(" "), (_vm.data.firstContractTLNo) ? _c('div', [_vm._v("\n      当年共有"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.firstContractTLBuyers))]), _vm._v("\n      与您选择了相同的载体\n      "), _c('br'), _vm._v("\n      科研道路上您并不孤单\n    ")]) : _c('div', [_vm._v("\n      成交只是起点，服务没有终点\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c525b70","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anniversary/PageContractFirst/index.vue
// module id = 1608
// module chunks = 8